<template>
  <div class="page-content this-transcript-class">
    <div class="class-list">
      <div class="search-wrap">
        <div class="search-options-wrap">
          <div class="option-item">
            <div class="option-title">{{ $t('public.status') }}</div>
            <a-select
              allowClear
              showSearch
              v-model="status"
              style="width: 100%"
              :placeholder="$t('public.status')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="getDataSource"
            >
              <a-select-option
                v-for="(item, index) in classTypeList"
                :key="index"
                :value="item.value"
              >
                {{ $t(item.label) }}
              </a-select-option>
            </a-select>
          </div>

          <div class="option-item">
            <div class="option-title">{{ $t('public.startedYear') }}</div>
            <a-select
              allowClear
              showSearch
              v-model="year"
              style="width: 100%"
              :placeholder="$t('public.startedYear')"
              :filterOption="filterOption"
              :dropdownMatchSelectWidth="false"
              @change="getDataSource"
            >
              <a-select-option
                v-for="(item, index) in yearList"
                :key="index"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <a-table
        size="middle"
        :rowKey="(record) => record.id"
        :loading="tableLoading"
        :dataSource="dataSource"
        :pagination="false"
        :customRow="
          (record) => {
            return {
              style: {
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  getClassGrade(record)
                },
              },
            }
          }
        "
      >
        <a-table-column
          :title="$t('public.class')"
          dataIndex="name"
        ></a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      campusId: localStorage.getItem('campusId'),

      status: undefined,
      year: undefined,

      // 班级
      tableLoading: false,
      dataSource: [],

      classId: '',
    }
  },

  computed: {
    ...mapGetters(['userId', 'classTypeList', 'yearList']),
  },

  created() {
    this.getDataSource()
  },

  methods: {
    // 搜索选项
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    // 班级
    getDataSource() {
      this.tableLoading = true
      this.$http(this.$api.GETLISTBYUSERID, {
        campusId: this.campusId, // 学习中心ID
        userId: this.userId,
        grade: this.status,
        openDate: this.year,
      }).then((r) => {
        this.dataSource = r.data
        this.tableLoading = false
      })
    },

    getClassGrade(record) {
      this.$router.push({
        name: this.$route.name,
        query: {
          type: 'classStudent',
          classId: record.id,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.this-transcript-class {
  padding-top: 0;
  padding-bottom: 0;
  min-height: calc(~'100% - @{switchComponentsHeight}');
  display: flex;
  @timetableTypeWidth: 420px;
  .class-list {
    padding: 15px 0;
    margin-bottom: -30px;
    width: @timetableTypeWidth;
    padding-right: 10px;
    border-right: 1px solid @lineColor;
    padding-bottom: 15px;
  }
}
</style>
